import React, { useEffect } from "react";
import { Redirect, useParams } from 'react-router-dom';
import api from "../../store/api";
import { useDispatch, useSelector } from "react-redux";
import { setpcrstate } from "../../store/modules/PcrSlice";
import { pcrstate } from "../../store/modules/PcrSlice";

function CreateUser(): JSX.Element {
  let { appId, isApp } = useParams<{ appId: string, isApp: string }>();
   
  const dispatch = useDispatch();

  dispatch(setpcrstate({name:"appId",value:appId}))
  dispatch(setpcrstate({name:"isApp",value: isApp=='true' ? true : false }))

  return (
    <Redirect to={{ pathname: '/' }} />
  );
};

export default CreateUser;
